export default __webpack_public_path__ + "f2d0f5b7b6833df4a1dd8432f15458cf.svg";